export class Address {
    id: string;
    uid: string;
    title: string;
    zoneNumber: string;
    streetNumber: string;
    buildingNumber: string;
    unitNumber: string;
    ownerOrTenant: string;
    latitude: string;
    longitude: string;
    deleted: boolean;
    constructor() {
        this.id = '';
        this.uid = '';
        this.title = '';
        this.zoneNumber = '';
        this.streetNumber = '';
        this.buildingNumber = '';
        this.unitNumber = '';
        this.ownerOrTenant = '';
        this.latitude = '';
        this.longitude = '';
        this.deleted = false;
    }
}
